import React from 'react';

import BaseComponentProperty from "../index";
import Style from "../Style";

export default class Accordion extends BaseComponentProperty {
    renderOwnProperties() {
        return (
            <div>
                <button className='button mb-2' onClick={() => {
                    let data = this.props.component.data;
                    let items = data.items;
                    items.push({
                        "title": {
                            "text": "",
                            "style": {}
                        },
                        "content": {
                            "html": "",
                            "style": {}
                        },
                        "header_color": "",
                        "icon": {
                            "class": "",
                            "style": {}
                        }
                    });
                    data.items = items;
                    this.props.onChange('data', data);
                }}>+
                </button>
                <div className='d-flex flex-row flex-wrap flex-gap-5'>
                    {this.props.component.data.items.map((item, index) => {
                        return (
                            <div key={index} style={{position: 'relative'}} className='bordered'>
                                <i
                                    className='fas fa-trash text-danger clickable'
                                    style={{position: 'absolute', right: 0, top: 0}}
                                    onClick={() => {
                                        let data = this.props.component.data;
                                        data.items.splice(index, 1);
                                        this.props.onChange('data', data);
                                    }}
                                />
                                <div>
                                    <label>Title</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={item.title && item.title.text ? item.title.text : ''}
                                            onChange={event => {
                                                let data = JSON.parse(JSON.stringify(this.props.component.data));
                                                let items = data.items;
                                                let item = items[index];
                                                item.title.text = event.target.value;
                                                items[index] = item;
                                                data.items = items;
                                                this.props.onChange('data', data);
                                            }}
                                        />
                                    </div>
                                </div>
                                <Style
                                    key={'title_' + index}
                                    initial={item.title && item.title.style ? item.title.style : ''}
                                    name='Title Styles'
                                    onChange={style => {
                                        let data = JSON.parse(JSON.stringify(this.props.component.data));
                                        let items = data.items;
                                        let item = items[index];
                                        item.title.style = style;
                                        items[index] = item;
                                        data.items = items;
                                        this.props.onChange('data', data);
                                    }}/>
                                <div>
                                    <label>Content</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={item.content && item.content.html ? item.content.html : ''}
                                            onChange={event => {
                                                let data = JSON.parse(JSON.stringify(this.props.component.data));
                                                let items = data.items;
                                                let item = items[index];
                                                item.content.html = event.target.value;
                                                items[index] = item;
                                                data.items = items;
                                                this.props.onChange('data', data);
                                            }}
                                        />
                                    </div>
                                </div>
                                <Style
                                    key={'content_' + index}
                                    initial={item.content && item.content.style ? item.content.style : ''}
                                    name='Content Styles'
                                    onChange={style => {
                                        let data = JSON.parse(JSON.stringify(this.props.component.data));
                                        let items = data.items;
                                        let item = items[index];
                                        item.content.style = style;
                                        items[index] = item;
                                        data.items = items;
                                        this.props.onChange('data', data);
                                    }}/>
                                <div>
                                    <label>Header color</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={item.header_color ? item.header_color : ''}
                                            onChange={event => {
                                                let data = JSON.parse(JSON.stringify(this.props.component.data));
                                                let items = data.items;
                                                let item = items[index];
                                                item.header_color = event.target.value;
                                                items[index] = item;
                                                data.items = items;
                                                this.props.onChange('data', data);
                                            }}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <label>Icon</label>
                                    <div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={item.icon && item.icon.class ? item.icon.class : ''}
                                            onChange={event => {
                                                let data = JSON.parse(JSON.stringify(this.props.component.data));
                                                let items = data.items;
                                                let item = items[index];
                                                item.icon.class = event.target.value;
                                                items[index] = item;
                                                data.items = items;
                                                this.props.onChange('data', data);
                                            }}
                                        />
                                    </div>
                                </div>
                                <Style
                                    key={'icon_' + index}
                                    initial={item.icon && item.icon.style ? item.icon.style : ''}
                                    name='Icon Styles'
                                    onChange={style => {
                                        let data = JSON.parse(JSON.stringify(this.props.component.data));
                                        let items = data.items;
                                        let item = items[index];
                                        item.icon.style = style;
                                        items[index] = item;
                                        data.items = items;
                                        this.props.onChange('data', data);
                                    }}/>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
